
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AutoCommunicationSettingsApi } from '../api/autocommunicationsettings.api';
import { switchMap, map } from 'rxjs/operators';

import { AutoCommunicationSettingsData, AutoCommunicationSettings } from '../../../interfaces/masters/autocommunicationsettings' ;
@Injectable()
export class AutoCommunicationSettingsService extends AutoCommunicationSettingsData {

    constructor(private api: AutoCommunicationSettingsApi) {
      super();
    }
  
  
    list(url: string): Observable<AutoCommunicationSettings[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<AutoCommunicationSettings>{
        return this.api.getById(url);
    }
  
    create(url: string, data:AutoCommunicationSettings[]): Observable<AutoCommunicationSettings[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:AutoCommunicationSettings): Observable<AutoCommunicationSettings> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
